import { Col, Container, Row, Stack } from "react-bootstrap";
import { getOffices } from "@/functions/getOffices";
import clsx from "classnames";
import classes from "./styles.module.scss";
import { DynamicText } from "@/ui/DynamicText";
import { useLocale } from "@/hooks/useLocale";
import Address from "@/assets/Address.svg";
import Map from "@/assets/Map.svg";
import Telephone from "@/assets/Telephone.svg";

export const ContactPageOfficesSection = ({ className }) => {
  const locale = useLocale();
  const offices = getOffices();

  return (
    <div className={className}>
      <Container>
        <Row>
          {offices.map(({ id, title, address, banner, map, telephone, url_slug, employment_registration_number }) => (
            <Col xs={12} key={id}>
              <a id={url_slug} />
              <div
                className={clsx(classes.office, "border mb-4 mb-md-5")}
                style={{ backgroundImage: `url(${banner})` }}
              >
                <div className="p-sm-4 d-flex align-items-center">
                  <h3 dangerouslySetInnerHTML={{ __html: title }} />
                </div>
                <div className="d-flex flex-column justify-content-center me-auto p-4 p-lg-5">
                  <dl className="px-2 mb-4">
                    <dt className="p-2">
                      <Telephone />
                    </dt>
                    <dd className="p-2" dangerouslySetInnerHTML={{ __html: telephone }} />
                  </dl>
                  <Stack className="d-flex flex-grow-0 flex-lg-row align-items-stretch me-auto bg-white-80 w-100 shadow">
                    <a href={map} target="_blank" className="bg-primary text-white">
                      <dl className="px-2">
                        <dt className="p-2">
                          <Map />
                        </dt>
                        <dd className="p-2">
                          <DynamicText path={`page.contact.office.map.${locale}`} />
                        </dd>
                      </dl>
                    </a>
                    <dl className="border-end flex-grow-1 px-2">
                      <dt className="p-2">
                        <Address />
                      </dt>
                      <dd className="p-2" dangerouslySetInnerHTML={{ __html: address }} />
                    </dl>
                  </Stack>
                  {
                    employment_registration_number && (
                      <dl className="  bg-white-80 shadow mt-5 mb-5" style={{ width: 'fit-content' }}>
                      <dt className="p-2">
                        Employment Registration Number:
                      </dt>
                      <dd
                        className="p-2"
                        dangerouslySetInnerHTML={{ __html: employment_registration_number }}
                      />
                    </dl>
                    )
                  }
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};
